/* © NXAPP Limited */
import { supabase } from './supabase'

/**
 * fetch() with the current Supabase access token attached.
 *
 * The owner-only API routes (anything that spends money or sends mail) verify
 * this token server-side. Without it they return 401, so every in-app call to
 * those routes must go through here rather than bare fetch().
 */
export async function authedFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const { data } = await supabase.auth.getSession()
  const token = data.session?.access_token
  const headers = new Headers(init.headers ?? {})
  if (token) headers.set('Authorization', `Bearer ${token}`)
  return fetch(input, { ...init, headers })
}
